import React, { useEffect, useState } from 'react';
import AdminSidebar from '../admin/AdminSidebar';
import AdminTopbar from '../admin/AdminTopbar';
import '../admin/admin-layout.css';

function AdminLayout({ children }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    if (typeof window === 'undefined') return true;
    // Desktop (>768px): sidebar open by default
    // Mobile/tablet (<=768px): sidebar closed by default
    return window.innerWidth > 768;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      // Ensure sidebar is open whenever we are on desktop.
      if (window.innerWidth > 768) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div
      className={
        `admin-layout ${isSidebarOpen ? 'sidebar-open' : 'sidebar-collapsed'}`
      }
    >
      <nav aria-label="Admin navigation">
        <AdminSidebar isOpen={isSidebarOpen} />
      </nav>
      <div className="admin-main">
        <header>
          <AdminTopbar onToggleSidebar={handleToggleSidebar} />
        </header>
        <main className="admin-content" role="main">
          {children}
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
